export function makeBatchExpandKey(strategyId, batchId) {
  return `${strategyId}::${batchId}`;
}

export function parseCreateBatchResponse(apiResponse) {
  const payload = apiResponse?.response ?? apiResponse?.data ?? apiResponse;
  const items = Array.isArray(payload) ? payload : payload ? [payload] : [];
  const first = items[0] || {};

  return {
    message: apiResponse?.message || "Batch created successfully.",
    batchId: first.batch_id || first.id || "",
    strategyId: first.strategy_id || "",
    description: first.desc || first.description || "",
  };
}

export const BATCH_TRADE_COLUMNS = [
  { key: "broker_code", label: "Broker Code", sortable: true },
  { key: "trading_symbol", label: "Trading Symbol", sortable: true },
  { key: "total_qty", label: "Total Qty", sortable: true },
  { key: "price", label: "Price", sortable: true },
  { key: "transaction", label: "Transaction", sortable: true },
  { key: "date_time", label: "Date & Time", sortable: true },
  { key: "expiry_date", label: "Expiry Date", sortable: true },
  { key: "batch_id", label: "Batch ID", sortable: true },
  { key: "exchange", label: "Exchange", sortable: true },
  { key: "symbol_type", label: "Symbol Type", sortable: true },
  { key: "strike", label: "Strike", sortable: true },
];

export function normalizeStrategySummary(strategy) {
  return {
    strategyId: strategy.strategy_id,
    strategyName: strategy.strategy_name || "Unknown",
    pnl: strategy.pnl || 0,
    tradeCount: strategy.trade_count || 0,
    batchCount: strategy.total_batch || 0,
  };
}

export function normalizeStrategyBatch(batch) {
  return {
    id: batch.id,
    strategyId: batch.strategy_id,
    strategyName: batch.strategy_name,
    description: batch.description || batch.batch_name || batch.id,
    createdAt: batch.created_at,
  };
}

export function normalizeBatchTradeRow(trade) {
  return {
    ...trade,
    id: trade.id,
    broker_code: trade.broker_code || trade.broker_client_code || "-",
    trading_symbol: trade.trading_symbol || trade.exchange_trading_symbol || trade.symbol || "-",
    total_qty: trade.total_qty ?? trade.traded_quantity ?? 0,
    price: trade.price ?? trade.traded_price ?? 0,
    transaction: trade.transaction ?? trade.transaction_type ?? "-",
    date_time: trade.date_time || trade.trade_timestamp || "-",
    expiry_date: trade.expiry_date || "-",
    batch_id: trade.batch_id || "-",
    exchange: trade.exchange || "-",
    symbol_type: trade.symbol_type || trade.instrument_type || trade.option_type || "-",
    strike: trade.strike ?? trade.strike_price ?? "-",
  };
}

export function normalizeBatchTrades(trades) {
  if (!Array.isArray(trades)) return [];
  return trades.map(normalizeBatchTradeRow);
}

export function sortStrategyBatchesByCreatedAt(batches) {
  if (!Array.isArray(batches)) return [];
  return [...batches].sort((a, b) => {
    const aTime = a.createdAt ? new Date(a.createdAt).getTime() : 0;
    const bTime = b.createdAt ? new Date(b.createdAt).getTime() : 0;
    const safeATime = Number.isNaN(aTime) ? 0 : aTime;
    const safeBTime = Number.isNaN(bTime) ? 0 : bTime;
    return safeBTime - safeATime;
  });
}

export function normalizeStrategyBatches(batches) {
  if (!Array.isArray(batches)) return [];
  return sortStrategyBatchesByCreatedAt(batches.map(normalizeStrategyBatch));
}

export function normalizeStrategySummaries(strategies) {
  if (!Array.isArray(strategies)) return [];
  return strategies
    .filter((strategy) => strategy.strategy_id != null)
    .map(normalizeStrategySummary);
}
